<template>
  <b-modal
    header-close-content=""
    :title="$t('Automapping.AdvancedMappingSettings')"
    :id="modalName"
    no-close-on-backdrop
    no-close-on-esc
    class="advanced-auto-mapping-dialog"
    body-class="advanced-auto-mapping-dialog-body"
    size="lg"
    @ok="saveSettings"
    @shown="init">
    <label>{{ $t("Automapping.SelectColumnRange") }}</label>
    <div class="d-flex flex-row justify-content-end">
      <menu-bar class="my-2" withoutBorder>
        <template #rightItems>
          <b-button class="btn btn-secondary" v-tooltip="$t('Automapping.Reset')" @click="reset()">
            <i class="mdp-Undo"></i><span class="ml-1">{{ $t("Automapping.Reset") }}</span>
          </b-button>
        </template>
      </menu-bar>
    </div>

    <div class="settings-column-wrapper">
      <div class="settings-column mr-3">
        <div class="settings-column-title">
          <h5>{{ $t("text.attributes") }}</h5>
        </div>
        <div class="settings-row">
          <label>{{ $t("Names") }}</label>
          <div class="settings-row-line">
            <input
              v-tooltip="getValidationFeedback(invariantAttributeNames.catalogMappingTargetFieldMappingId + '_targetFieldLowerBound')"
              class="form-control number-input"
              :class="{ 'border-danger': !getValidationIsValid(invariantAttributeNames.catalogMappingTargetFieldMappingId + '_targetFieldLowerBound') }"
              type="number"
              v-model="invariantAttributeNames.targetFieldLowerBound" />
            <span class="interval-separator">-</span>
            <input
              v-tooltip="getValidationFeedback(invariantAttributeNames.catalogMappingTargetFieldMappingId + '_targetFieldUpperBound')"
              class="form-control number-input"
              :class="{
                'border-danger': !getValidationIsValid(invariantAttributeNames.catalogMappingTargetFieldMappingId + '_targetFieldUpperBound')
              }"
              type="number"
              v-model="invariantAttributeNames.targetFieldUpperBound" />
          </div>
        </div>
        <div class="settings-row">
          <label>{{ $t("Values") }}</label>
          <div class="settings-row-line">
            <input
              v-tooltip="getValidationFeedback(invariantAttributeValues.catalogMappingTargetFieldMappingId + '_targetFieldLowerBound')"
              class="form-control number-input"
              :class="{ 'border-danger': !getValidationIsValid(invariantAttributeValues.catalogMappingTargetFieldMappingId + '_targetFieldLowerBound') }"
              type="number"
              v-model="invariantAttributeValues.targetFieldLowerBound" />
            <span class="interval-separator">-</span>
            <input
              v-tooltip="getValidationFeedback(invariantAttributeValues.catalogMappingTargetFieldMappingId + '_targetFieldUpperBound')"
              class="form-control number-input"
              :class="{ 'border-danger': !getValidationIsValid(invariantAttributeValues.catalogMappingTargetFieldMappingId + '_targetFieldUpperBound') }"
              type="number"
              v-model="invariantAttributeValues.targetFieldUpperBound" />
          </div>
        </div>
        <div class="settings-row">
          <label>{{ $t("Units") }}</label>
          <div class="settings-row-line">
            <input
              v-tooltip="getValidationFeedback(invariantAttributeUnits.catalogMappingTargetFieldMappingId + '_targetFieldLowerBound')"
              class="form-control number-input"
              :class="{ 'border-danger': !getValidationIsValid(invariantAttributeUnits.catalogMappingTargetFieldMappingId + '_targetFieldLowerBound') }"
              type="number"
              v-model="invariantAttributeUnits.targetFieldLowerBound" />
            <span class="interval-separator">-</span>
            <input
              v-tooltip="getValidationFeedback(invariantAttributeUnits.catalogMappingTargetFieldMappingId + '_targetFieldUpperBound')"
              class="form-control number-input"
              :class="{ 'border-danger': !getValidationIsValid(invariantAttributeUnits.catalogMappingTargetFieldMappingId + '_targetFieldUpperBound') }"
              type="number"
              v-model="invariantAttributeUnits.targetFieldUpperBound" />
          </div>
        </div>
      </div>
      <div class="table-splitter"></div>
      <div class="settings-column ml-3">
        <div class="settings-column-title">
          <h5>{{ $t("table.attributes") }}</h5>
        </div>
        <div class="settings-row">
          <label>{{ $t("Names") }}</label>
          <div class="settings-row-line">
            <input
              v-tooltip="getValidationFeedback(variantAttributeNames.catalogMappingTargetFieldMappingId + '_targetFieldLowerBound')"
              class="form-control number-input"
              :class="{ 'border-danger': !getValidationIsValid(variantAttributeNames.catalogMappingTargetFieldMappingId + '_targetFieldLowerBound') }"
              type="number"
              v-model="variantAttributeNames.targetFieldLowerBound" />
            <span class="interval-separator">-</span>
            <input
              v-tooltip="getValidationFeedback(variantAttributeNames.catalogMappingTargetFieldMappingId + '_targetFieldUpperBound')"
              class="form-control number-input"
              :class="{ 'border-danger': !getValidationIsValid(variantAttributeNames.catalogMappingTargetFieldMappingId + '_targetFieldUpperBound') }"
              type="number"
              v-model="variantAttributeNames.targetFieldUpperBound" />
          </div>
        </div>
        <div class="settings-row">
          <label>{{ $t("Values") }}</label>
          <div class="settings-row-line">
            <input
              v-tooltip="getValidationFeedback(variantAttributeValues.catalogMappingTargetFieldMappingId + '_targetFieldLowerBound')"
              class="form-control number-input"
              :class="{ 'border-danger': !getValidationIsValid(variantAttributeValues.catalogMappingTargetFieldMappingId + '_targetFieldLowerBound') }"
              type="number"
              v-model="variantAttributeValues.targetFieldLowerBound" />
            <span class="interval-separator">-</span>
            <input
              v-tooltip="getValidationFeedback(variantAttributeValues.catalogMappingTargetFieldMappingId + '_targetFieldUpperBound')"
              class="form-control number-input"
              :class="{ 'border-danger': !getValidationIsValid(variantAttributeValues.catalogMappingTargetFieldMappingId + '_targetFieldUpperBound') }"
              type="number"
              v-model="variantAttributeValues.targetFieldUpperBound" />
          </div>
        </div>
        <div class="settings-row">
          <label>{{ $t("Units") }}</label>
          <div class="settings-row-line">
            <input
              v-tooltip="getValidationFeedback(variantAttributeUnits.catalogMappingTargetFieldMappingId + '_targetFieldLowerBound')"
              class="form-control number-input"
              :class="{ 'border-danger': !getValidationIsValid(variantAttributeUnits.catalogMappingTargetFieldMappingId + '_targetFieldLowerBound') }"
              type="number"
              v-model="variantAttributeUnits.targetFieldLowerBound" />
            <span class="interval-separator">-</span>
            <input
              v-tooltip="getValidationFeedback(variantAttributeUnits.catalogMappingTargetFieldMappingId + '_targetFieldUpperBound')"
              class="form-control number-input"
              :class="{ 'border-danger': !getValidationIsValid(variantAttributeUnits.catalogMappingTargetFieldMappingId + '_targetFieldUpperBound') }"
              type="number"
              v-model="variantAttributeUnits.targetFieldUpperBound" />
          </div>
        </div>
      </div>
    </div>

    <template #modal-footer="{ ok, cancel }">
      <b-btn @click="ok" :disabled="isModalInvalid" variant="primary">{{ $t("OK") }}</b-btn>
      <b-btn @click="cancel">{{ $t("Cancel") }}</b-btn>
    </template>
  </b-modal>
</template>

<script>
import MenuBar from "@common/components/MenuBar/MenuBar.vue";
import automappingApi from "@services/automapping.js";

export default {
  components: { MenuBar },
  data() {
    return {
      advancedAutoMappingSettings: [],
      defaultSettings: { targetFieldLowerBound: 0, targetFieldUpperBound: 0 }
    };
  },
  props: ["modalName", "catalogMappingTargetId"],
  computed: {
    invariantAttributeNames() {
      return this.advancedAutoMappingSettings.find((def) => def.sourceFieldPath == "InvariantAttributes\\Names") ?? this.defaultSettings;
    },
    invariantAttributeValues() {
      return this.advancedAutoMappingSettings.find((def) => def.sourceFieldPath == "InvariantAttributes\\Values") ?? this.defaultSettings;
    },
    invariantAttributeUnits() {
      return this.advancedAutoMappingSettings.find((def) => def.sourceFieldPath == "InvariantAttributes\\Units") ?? this.defaultSettings;
    },
    variantAttributeNames() {
      return this.advancedAutoMappingSettings.find((def) => def.sourceFieldPath == "VariantAttributes\\Names") ?? this.defaultSettings;
    },
    variantAttributeValues() {
      return this.advancedAutoMappingSettings.find((def) => def.sourceFieldPath == "VariantAttributes\\Values") ?? this.defaultSettings;
    },
    variantAttributeUnits() {
      return this.advancedAutoMappingSettings.find((def) => def.sourceFieldPath == "VariantAttributes\\Units") ?? this.defaultSettings;
    },
    validationFeedBack() {
      const validationFeedBack = [];
      this.advancedAutoMappingSettings.forEach((def) => {
        if (def.targetFieldLowerBound && def.targetFieldLowerBound == "") {
          validationFeedBack[def.catalogMappingTargetFieldMappingId + "_targetFieldLowerBound"] = {
            isValid: false,
            feedback: this.$t("validation.valueRequired", {
              field: "Lower bound"
            }),
            severity: "error"
          };
        } else if (this.isNotAValidNumber(def.targetFieldLowerBound)) {
          validationFeedBack[def.catalogMappingTargetFieldMappingId + "_targetFieldLowerBound"] = {
            isValid: false,
            feedback: this.$t("validation.dataTypeNotNumerical"),
            severity: "error"
          };
        } else if (def.targetFieldUpperBound && def.targetFieldUpperBound == "") {
          validationFeedBack[def.catalogMappingTargetFieldMappingId + "_targetFieldUpperBound"] = {
            isValid: false,
            feedback: this.$t("validation.valueRequired", {
              field: "Upper bound"
            }),
            severity: "error"
          };
        } else if (this.isNotAValidNumber(def.targetFieldUpperBound)) {
          validationFeedBack[def.catalogMappingTargetFieldMappingId + "_targetFieldUpperBound"] = {
            isValid: false,
            feedback: this.$t("validation.dataTypeNotNumerical"),
            severity: "error"
          };
        } else if (parseInt(def.targetFieldUpperBound) <= parseInt(def.targetFieldLowerBound)) {
          validationFeedBack[def.catalogMappingTargetFieldMappingId + "_targetFieldUpperBound"] = {
            isValid: false,
            feedback: this.$t("validation.upperBoundGreaterThanLowerBound"),
            severity: "error"
          };
        } else if (this.isRangeOverlapping(def)) {
          validationFeedBack[def.catalogMappingTargetFieldMappingId + "_targetFieldLowerBound"] = {
            isValid: false,
            feedback: this.$t("validation.rangesOverlap"),
            severity: "error"
          };
          validationFeedBack[def.catalogMappingTargetFieldMappingId + "_targetFieldUpperBound"] = {
            isValid: false,
            feedback: this.$t("validation.rangesOverlap"),
            severity: "error"
          };
        }
      });
      return validationFeedBack;
    },
    isModalInvalid() {
      return Object.keys(this.validationFeedBack)
        .map((key) => this.validationFeedBack[key])
        .some((row) => !row.isValid);
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init: async function () {
      if (this.catalogMappingTargetId) {
        this.advancedAutoMappingSettings = await automappingApi.getAdvancedSettings(this.catalogMappingTargetId);
      } else {
        this.advancedAutoMappingSettings = [];
      }
    },
    reset() {
      const isReset = confirm(this.$t("Automapping.ResetToDefaultQuestion"));

      if (isReset) {
        this.invariantAttributeNames.targetFieldLowerBound = 100;
        this.invariantAttributeNames.targetFieldUpperBound = 199;
        this.invariantAttributeValues.targetFieldLowerBound = 200;
        this.invariantAttributeValues.targetFieldUpperBound = 299;
        this.invariantAttributeUnits.targetFieldLowerBound = 300;
        this.invariantAttributeUnits.targetFieldUpperBound = 399;
        this.variantAttributeNames.targetFieldLowerBound = 400;
        this.variantAttributeNames.targetFieldUpperBound = 499;
        this.variantAttributeValues.targetFieldLowerBound = 500;
        this.variantAttributeValues.targetFieldUpperBound = 599;
        this.variantAttributeUnits.targetFieldLowerBound = 600;
        this.variantAttributeUnits.targetFieldUpperBound = 699;
      }
    },
    isRangeOverlapping(objectToCompare) {
      const obj1 = objectToCompare;
      for (let i = 0; i < this.advancedAutoMappingSettings.length; i++) {
        const obj2 = this.advancedAutoMappingSettings[i];
        if (obj2.catalogMappingTargetFieldMappingId != obj1.catalogMappingTargetFieldMappingId) {
          if (!this.isNotAValidNumber(obj2.targetFieldLowerBound) && !this.isNotAValidNumber(obj2.targetFieldUpperBound)) {
            const lowerBound1 = parseInt(obj1.targetFieldLowerBound);
            const upperBound1 = parseInt(obj1.targetFieldUpperBound);
            const lowerBound2 = parseInt(obj2.targetFieldLowerBound);
            const upperBound2 = parseInt(obj2.targetFieldUpperBound);

            if (!((lowerBound1 < upperBound2 && lowerBound2 > upperBound1) || (lowerBound1 > upperBound2 && lowerBound2 < upperBound1))) {
              return true;
            }
          }
        }
      }
      return false;
    },
    isNotAValidNumber(value) {
      if (!value || value == "" || isNaN(value) || parseInt(value) != value) {
        return true;
      } else {
        return false;
      }
    },
    saveSettings: async function () {
      await automappingApi.saveAdvancedSettings(this.advancedAutoMappingSettings);
    },
    getValidationFeedback(entry) {
      return this.validationFeedBack?.[entry]?.feedback ?? false;
    },
    getValidationIsValid(entry) {
      return this.validationFeedBack?.[entry]?.isValid ?? true;
    }
  }
};
</script>
